module.exports = __webpack_public_path__ + "img/pr-6.88d6e8fd.png";